import { IProductNew } from 'interfaces/product';
import React, { useCallback, useRef, useState } from 'react';
import { productNewService } from 'services/productNewService';
import List from './List';
import { ListOptionProduct } from './ListProducts';
import Search from './Search';
import { useStyles } from './styles';

interface ISelectProductsProps {
  data: IProductNew[];
  defaultBackRedirectId?: string;
  onSelectedId: (id: string | null) => void;
}

const matchProduct = (matcher: string) => (prd: IProductNew) => String(prd?.hashId || prd?.id) === matcher;

export default function SelectProduct({ data, defaultBackRedirectId, onSelectedId }: ISelectProductsProps) {
  const classes = useStyles();
  const containerRef = useRef<HTMLDivElement>(null);

  const [items, setItems] = useState(data);
  const [show, setShow] = useState(false);

  const [selectedProductName, setSelectedProductName] = useState(() => {
    if (!defaultBackRedirectId) {
      return '';
    }

    const backRedirectItem = data?.find(matchProduct(defaultBackRedirectId));

    if (!!backRedirectItem) {
      return `${backRedirectItem?.id} - ${backRedirectItem?.name}`;
    }

    let childItem: IProductNew = null;
    data?.find(product => {
      childItem = product?.children?.find(matchProduct(defaultBackRedirectId));
      return !!childItem;
    });

    return childItem ? `${childItem?.id} - ${childItem?.name}` : '';
  });

  const handleOnChange = useCallback(
    (value: string) => {
      onSelectedId(null);
      setItems(productNewService.filterProductsBySearch(value));
    },
    [onSelectedId]
  );

  const handleOnSelected = useCallback(
    (product: IProductNew | null) => {
      if (!product) {
        return;
      }

      setShow(false);
      onSelectedId(String(product.hashId || product.id));
      setSelectedProductName(`${product.id} - ${product.name}`);
    },
    [onSelectedId]
  );

  const openList = () => {
    setShow(true);
  };

  const toggleList = () => {
    setShow(prev => !prev);
  };

  return (
    <div ref={containerRef} className={classes.container}>
      <Search
        onChange={handleOnChange}
        selectedValue={selectedProductName}
        open={openList}
        toggle={toggleList}
        isOpen={show}
      />

      <List<IProductNew>
        show={show}
        options={items}
        option={(product, index) => (
          <ListOptionProduct key={product.id} product={product} onSelected={handleOnSelected} isFirst={index === 0} />
        )}
      />
    </div>
  );
}
